import { useEffect, useState, useRef } from "react";
import { getLegalTextBySponsor, ENDPOINTS } from '../../functions/functions.js';
import { getCarrouselSponsoredUno } from "../../services/getCarrouselSponsoredUno.js";
import WidgetContainer from "../reusablesComponents/containerWidget.js";
import Legal from "../legal/legal.js";
import Carrousel from "../reusablesComponents/carrousel.js";
import NoEvents from '../noEvents/noEvents.js';
import "./carrouselSponsoredUno.sass";

/**
 * Componente que renderiza un carrusel con eventos patrocinados para unotv.
 * Carga la data desde el endpoint correcto según la URL y muestra un aviso legal si aplica.
 */
export default function CarrouselSponsoredUno({ patrocinador: sponsor, flagMomios }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false); // Flag para errores no-200
  const hasLoadedRef = useRef(false); // Flag para evitar carga duplicada

  const activeMomios = flagMomios === true || flagMomios === "true";
  const legalText = getLegalTextBySponsor(sponsor);

  // Fetch de datos al cargar componente - evitar duplicados
  useEffect(() => {
    // Evitar ejecución duplicada
    if (hasLoadedRef.current) return;
    
    const fetchData = async () => {
      hasLoadedRef.current = true; // Marcar como cargado inmediatamente
      setLoading(true);
      try {
        const response = await getCarrouselSponsoredUno({ endpoint: ENDPOINTS.unotv });
                
        // Verificar si el statusCode es 200
        if (response?.statusCode === 200) {
          const responseData = Array.isArray(response?.data) ? response.data : [];
          setData(responseData);
          setHasError(false);
        } else {
          // Si no es 200 (ej: 404), mostrar NoEvents
          console.warn('Servicio no respondió con 200:', response?.statusCode);
          setData([]);
          setHasError(true);
        }
      } catch (error) {
        console.error("Error al obtener datos:", error);
        setData([]);
        setHasError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <WidgetContainer loading={loading} heightLoading={115} className="container__carrousel-sponsoredUno" id="container__carrousel-sponsoredUno">
      {hasError ? (
        <NoEvents />
      ) : (
        <>
          <div className="carrousel-sponsoredUno__left-right">
            <Carrousel
              data={data}
              cardWidth={130}
              activeMomios={flagMomios}
              loading={loading}
              patrocinador={sponsor}
              classCarrousel="carrousel-card-sponsoredUno"
              classPrefix="carrousel-sponsoredUno-right"
              indexJson={0}
            />
          </div>

          {/* mostrar leyenda de copy legal */}
          {activeMomios && !loading && legalText.trim().length > 0 && (
            <Legal patrocinador={sponsor} />
          )}
        </>
      )}
    </WidgetContainer>
  )
}